import Script from 'next/script';
import { RenderAfterInteract } from 'src/modules/interact-watcher';
import { useAppSelector } from 'src/redux/hooks';
import { useAppConfig } from 'src/utils/appConfig/useAppConfig';

export default function RecaptchaScript() {
  const {
    settings: { RECAPTCHA_PUBLIC_KEY },
  } = useAppConfig();
  const language = useAppSelector((s) => s.app.language);

  if (!RECAPTCHA_PUBLIC_KEY) {
    return null;
  }

  return (
    <RenderAfterInteract>
      <Script
        id='recaptcha-script'
        src={`https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_PUBLIC_KEY}&hl=${language}`}
        strategy='afterInteractive'
        type='text/javascript'
      />

      <style jsx global>{`
        .grecaptcha-badge {
          z-index: 9999;
          opacity: 0;
          pointer-events: none;
          visibility: hidden;
        }
      `}</style>
    </RenderAfterInteract>
  );
}
